import { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import { useAuth } from "../pages/login/AuthProvider";
import "../styles/navbar.scss";

export default function MNavbar() {
  const { authorized, chinese_name, account, logout } = useAuth();

  const displayName =
    !chinese_name || chinese_name === account
      ? account?.split("@")[0] ?? ""
      : chinese_name;

  const [showNavbar, setShowNavbar] = useState(true);
  const lastYRef = useRef(0);
  const tickingRef = useRef(false);

  useEffect(() => {
    const onScroll = () => {
      if (!tickingRef.current) {
        window.requestAnimationFrame(() => {
          const currentY = window.scrollY;
          const goingDown = currentY > lastYRef.current;

          if (goingDown && currentY > 80) {
            setShowNavbar(false);
          } else {
            setShowNavbar(true);
          }

          lastYRef.current = currentY;
          tickingRef.current = false;
        });
        tickingRef.current = true;
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Navbar
      expand="xl"
      variant="dark"
      fixed="top"
      className={`custom-navbar ${showNavbar ? "show" : "hide"}`}
      style={{ backgroundColor: "#152046", transition: "transform 0.3s ease" }}
    >
      <div className="container d-flex align-items-center">

        {/* 左邊 Logo */}
        <NavLink className="navbar-brand logo me-3" to="/">
          <img src="/logo/logo.svg" alt="Logo" />
        </NavLink>

        {/* 👉 手機版右側：耳機 + 會員 + 漢堡 */}
        <div className="d-flex align-items-center ms-auto d-xl-none">
          <a
            href="https://a310.itraining.tw/"
            className="me-3 text-white"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-solid fa-headphones" />
          </a>

          {authorized ? (
            <NavLink to="/member" className="text-white me-2">
              <i className="fa-solid fa-user" />
            </NavLink>
          ) : (
            <Link to="/member/memberlogin" className="text-white me-2">
              <i className="fa-solid fa-user" />
            </Link>
          )}

          <Navbar.Toggle aria-controls="mnavbarScroll" />
        </div>

        {/* 展開內容 */}
        <Navbar.Collapse id="mnavbarScroll" className="flex-grow-1">

          {/* 中間主選單 */}
          <Nav className="mx-auto d-flex flex-column flex-xl-row align-items-xl-center">
            <Nav.Item>
              <NavLink className="nav-link" to="/about/origin">
                關於捷進
              </NavLink>
            </Nav.Item>
            <Nav.Item>
              <NavLink className="nav-link" to="/becker">
                美國 Becker
              </NavLink>
            </Nav.Item>
            <Nav.Item>
              <NavLink className="nav-link" to="/cpa">
                國際證照考試
              </NavLink>
            </Nav.Item>
            <Nav.Item>
              <NavLink className="nav-link" to="/service">
                服務項目
              </NavLink>
            </Nav.Item>
            <Nav.Item>
              <Link className="nav-link" to="/share">
                成功案例
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link className="nav-link" to="/video">
                影音專區
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link className="nav-link" to="/faq">
                FAQ
              </Link>
            </Nav.Item>
          </Nav>

          {/* 🔥👉 新增：手機版會員資訊 + 登出（只有 xl 以下會顯示） */}
          {authorized && (
            <div className="d-flex flex-column align-items-start d-xl-none mt-3 text-white ps-3">
              <div className="d-flex align-items-center mb-2">
                <i className="fa-solid fa-user me-2" />
                <span className="memname">{displayName}</span>
              </div>

              <div
                className="logouttext"
                onClick={() => logout()}
                style={{ cursor: "pointer" }}
              >
                登出
              </div>
            </div>
          )}

          {/* 👉 桌機版右側（XL 以上） */}
          <div className="d-none d-xl-flex align-items-center ms-3 text-white">
            <a
              href="https://a310.itraining.tw/"
              className="me-3 text-white"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa-solid fa-headphones" />
            </a>

            {authorized ? (
              <div className="d-flex align-items-center">
                <NavLink to="/member" className="text-white me-3">
                  <i className="fa-solid fa-user" />
                </NavLink>
                <div className="memname me-3">{displayName}</div>
                <div
                  className="text-white logouttext"
                  onClick={() => logout()}
                  style={{ cursor: "pointer" }}
                >
                  登出
                </div>
              </div>
            ) : (
              <Link to="/member/memberlogin" className="text-white">
                <i className="fa-solid fa-user" />
              </Link>
            )}
          </div>
        </Navbar.Collapse>

      </div>
    </Navbar>
  );
}
